exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".my-uploaded-template[data-v-41ce7658]{min-height:100px;margin-top:-35px}", ""]);

